function _jade_template_fn(locals) {
  locals = locals || {};;;
  var result_of_with = (function($attr, $component, $helpers, $hooks, Array, JSON, Number, String, document, keydownProxyEl, openModal, resourceType, searchFilter, selectedTab, stagedCohort, stagedCohortIndex, stagedCustomProperty, stagedMenuType, stagedProperty, stagedSearchFilter, tooltipData) {
    var h = require("panel").h;
    var __vjadeSafeCode = function(code) {
      return code || String(code);
    };
    const tabs = $helpers.getToggleTabs();;
    return {
      value: (h("div", {
        "class": {
          'mp-properties-menu': true
        },
      }, (function() {
        var __jade_nodes = [];
        __jade_nodes = __jade_nodes.concat((stagedProperty) ? ((function() {
          var __jade_nodes = [];
          __jade_nodes = __jade_nodes.concat(h("mp-drop-menu-pane", {
            "attrs": {
              'header': $helpers.getStagedMenuHeader(),
              'show-back-button': true,
            },
            "on": {
              'back-click': $helpers.unstageProperty
            },
          }, (function() {
            var __jade_nodes = [];
            __jade_nodes = __jade_nodes.concat(($helpers.isInnerContentSearchable()) ? ((function() {
              var __jade_nodes = [];
              __jade_nodes = __jade_nodes.concat(h("div", {
                "class": {
                  'search-wrapper': true
                },
              }, (function() {
                var __jade_nodes = [];
                __jade_nodes = __jade_nodes.concat(h("mp-icon-input", {
                  "attrs": {
                    'icon': 'search',
                    'placeholder': `Search ${stagedProperty.name}...`,
                    'value': stagedSearchFilter,
                  },
                  "on": {
                    input: $helpers.handleSearchInput,
                  },
                }));;
                return __jade_nodes
              }).call(this).filter(Boolean)));;
              return __jade_nodes
            }).call(this)) : undefined);
            __jade_nodes = __jade_nodes.concat(h("mp-items-menu", {
              "attrs": {
                'empty-message': `No items found`,
                'search-filter': stagedMenuType === $helpers.StagedMenuTypes.Dimension ? stagedSearchFilter : ``,
              },
              "props": {
                sections: $helpers.getStagedMenuSections(),
                keydownProxyEl: document.body,
                /* allow keyboard navigation for selection */
              },
              "hook": {
                insert: $helpers.handleItemsMenuInsert,
              },
              "on": {
                clickItem: $helpers.applyStagedValue,
                clickPill: $helpers.onItemPillClick,
              },
            }));;
            return __jade_nodes
          }).call(this).filter(Boolean)));;
          return __jade_nodes
        }).call(this)) : ((function() {
          var __jade_nodes = [];
          __jade_nodes = __jade_nodes.concat(h("div", {
            "class": {
              'mp-properties-menu-header': true
            },
          }, (function() {
            var __jade_nodes = [];
            __jade_nodes = __jade_nodes.concat((tabs.length > 1) ? ((function() {
              var __jade_nodes = [];
              __jade_nodes = __jade_nodes.concat(h("mp-toggle", {
                "attrs": {
                  'selected': selectedTab,
                  'theme': `lite`,
                },
                "key": `tabs-${tabs.length}` /* a terrible hack for adding mp-toggle children */ ,
                "on": {
                  select: $helpers.selectOption
                },
              }, (function() {
                var __jade_nodes = [];
                __jade_nodes = __jade_nodes.concat((function() {
                  var $$obj = (tabs);
                  var $$eachNodes;
                  var $$iterated = false;
                  if (Array.isArray($$obj)) {
                    $$eachNodes = $$obj.reduce(function($$eachNodes, tab, $index) {
                      $$iterated = true;
                      return $$eachNodes.concat((function() {
                        var __jade_nodes = [];
                        __jade_nodes = __jade_nodes.concat(h("mp-toggle-option", {
                          "attrs": {
                            value: tab.value,
                            disabled: tab.disabled,
                          },
                        }, [__vjadeSafeCode(tab.label)]));;
                        return __jade_nodes
                      }).call(this));
                    }, []);
                  } else {
                    $$eachNodes = [];
                    for (var $$objKey in $$obj) {
                      (function() {
                        var $index = $$objKey;
                        if ($$obj.hasOwnProperty($index)) {
                          $$iterated = true;
                          var tab = $$obj[$index];
                          $$eachNodes = $$eachNodes.concat((function() {
                            var __jade_nodes = [];
                            __jade_nodes = __jade_nodes.concat(h("mp-toggle-option", {
                              "attrs": {
                                value: tab.value,
                                disabled: tab.disabled,
                              },
                            }, [__vjadeSafeCode(tab.label)]));;
                            return __jade_nodes
                          }).call(this));
                        }
                      })();
                    }
                  }

                  return $$eachNodes;
                })());;
                return __jade_nodes
              }).call(this).filter(Boolean)));;
              return __jade_nodes
            }).call(this)) : undefined);
            __jade_nodes = __jade_nodes.concat(h("slot", {
              "attrs": {
                name: `menu-header`
              },
            }));;
            return __jade_nodes
          }).call(this).filter(Boolean)));
          __jade_nodes = __jade_nodes.concat(h("mp-items-menu", {
            "attrs": {
              'empty-message': `No items found`,
              'multiple': $helpers.useMultipleSelection(),
              'progressive': true,
              'search-filter': searchFilter || $attr(`search-filter`),
            },
            "on": {
              click: ev => ev.stopPropagation(),
              clickItem: $helpers.onItemClick,
              clickPill: $helpers.onItemPillClick,
              focusItem: $helpers.showItemDetails,
            },
            "props": {
              keydownProxyEl,
              sections: $helpers.getMenuSections(),
              sectionFromInputFn: input => $helpers.sectionFromInput(input, resourceType = selectedTab),
            },
            "hook": {
              insert: $helpers.handleItemsMenuInsert,
            },
          }));
          __jade_nodes = __jade_nodes.concat(h("mp-context-panel", {
            "attrs": {
              'tooltip-data': $attr(`open`) && openModal === null && JSON.stringify(tooltipData)
            },
            "props": {
              tooltipPositionParentElement: $component.tooltipPositionParentElement
            },
            "on": {
              tooltipContextAction: $helpers.handleTooltipContextAction
            },
          }));;
          return __jade_nodes
        }).call(this)));
        __jade_nodes = __jade_nodes.concat(($attr(`support-inline-cohorts`)) ? ((function() {
          var __jade_nodes = [];
          const inlineCohortModalType = $helpers.MODAL_TYPE.InlineCohort;;
          __jade_nodes = __jade_nodes.concat((openModal === inlineCohortModalType) ? ((function() {
            var __jade_nodes = [];
            __jade_nodes = __jade_nodes.concat(h("mp-inline-cohorts-modal", {
              "hook": {
                remove: $hooks.delayedAttrRemove(`open`, false)
              },
              "attrs": {
                open: true,
                type: $attr(`cohort-operation-type`),
                'is-new-cohort-definition': !Number.isInteger(stagedCohortIndex),
                'name': stagedCohort && stagedCohort.name,
                'staged-cohort': stagedCohort && JSON.stringify(stagedCohort.serialize()),
                'project-id': $attr(`project-id`),
                'workspace-id': $attr(`workspace-id`),
                'user-id': $attr(`user-id`),
                'data-group-id': $attr(`data-group-id`),
                'project-has-cohorts': $attr(`project-has-cohorts`),
                'testref': `inlineCohortsModal`,
                'can-save': !stagedCohort || !stagedCohort.dataGroupId,
              },
              "on": {
                change: ev => $helpers.applyModalState(inlineCohortModalType, ev.detail.state),
                stagedCohortUpdated: $helpers.updateStagedCohort,
                commitStagedCohort: $helpers.commitStagedCohort,
                commitSavedCohort: $helpers.commitSavedCohort,
              },
            }));;
            return __jade_nodes
          }).call(this)) : undefined);;
          return __jade_nodes
        }).call(this)) : undefined);
        __jade_nodes = __jade_nodes.concat((openModal === $helpers.MODAL_TYPE.CustomProperty) ? ((function() {
          var __jade_nodes = [];
          __jade_nodes = __jade_nodes.concat(h("mp-custom-property-modal", {
            "hook": {
              remove: $hooks.delayedAttrRemove(`open`, false)
            },
            "attrs": {
              'default-name': $helpers.getDefaultFormulaName(),
              'enable-behavioral-properties': $attr('enable-behavioral-properties'),
              'open': true,
              'project-id': $attr(`project-id`),
              'user-id': $attr(`user-id`),
              'property': JSON.stringify(stagedCustomProperty.property),
              'workspace-id': $attr(`workspace-id`),
            },
            "on": {
              cancel: $helpers.closeCustomPropertyModal,
              apply: $helpers.applyCustomProperty,
              delete: $helpers.deletedCustomProperty,
            },
          }));;
          return __jade_nodes
        }).call(this)) : undefined);;
        return __jade_nodes
      }).call(this).filter(Boolean)))
    };
  }.call(this, "$attr" in locals ? locals.$attr : typeof $attr !== "undefined" ? $attr : undefined, "$component" in locals ? locals.$component : typeof $component !== "undefined" ? $component : undefined, "$helpers" in locals ? locals.$helpers : typeof $helpers !== "undefined" ? $helpers : undefined, "$hooks" in locals ? locals.$hooks : typeof $hooks !== "undefined" ? $hooks : undefined, "Array" in locals ? locals.Array : typeof Array !== "undefined" ? Array : undefined, "JSON" in locals ? locals.JSON : typeof JSON !== "undefined" ? JSON : undefined, "Number" in locals ? locals.Number : typeof Number !== "undefined" ? Number : undefined, "String" in locals ? locals.String : typeof String !== "undefined" ? String : undefined, "document" in locals ? locals.document : typeof document !== "undefined" ? document : undefined, "keydownProxyEl" in locals ? locals.keydownProxyEl : typeof keydownProxyEl !== "undefined" ? keydownProxyEl : undefined, "openModal" in locals ? locals.openModal : typeof openModal !== "undefined" ? openModal : undefined, "resourceType" in locals ? locals.resourceType : typeof resourceType !== "undefined" ? resourceType : undefined, "searchFilter" in locals ? locals.searchFilter : typeof searchFilter !== "undefined" ? searchFilter : undefined, "selectedTab" in locals ? locals.selectedTab : typeof selectedTab !== "undefined" ? selectedTab : undefined, "stagedCohort" in locals ? locals.stagedCohort : typeof stagedCohort !== "undefined" ? stagedCohort : undefined, "stagedCohortIndex" in locals ? locals.stagedCohortIndex : typeof stagedCohortIndex !== "undefined" ? stagedCohortIndex : undefined, "stagedCustomProperty" in locals ? locals.stagedCustomProperty : typeof stagedCustomProperty !== "undefined" ? stagedCustomProperty : undefined, "stagedMenuType" in locals ? locals.stagedMenuType : typeof stagedMenuType !== "undefined" ? stagedMenuType : undefined, "stagedProperty" in locals ? locals.stagedProperty : typeof stagedProperty !== "undefined" ? stagedProperty : undefined, "stagedSearchFilter" in locals ? locals.stagedSearchFilter : typeof stagedSearchFilter !== "undefined" ? stagedSearchFilter : undefined, "tooltipData" in locals ? locals.tooltipData : typeof tooltipData !== "undefined" ? tooltipData : undefined));
  if (result_of_with) return result_of_with.value;
}
module.exports = _jade_template_fn;